import {connect} from "react-redux";
import { useNavigate } from "react-router-dom";

const Button_Logout = (props) => {
    const navigate = useNavigate();

    const logout = async () => {
        try {
            fetch("/logout", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                }
            })
            .then(res => {
                if (res.status == 200) {
                    navigate("/start")
                }
            })
        } catch (error) {
            console.log(error);
        }
    }
    return(
        <div onClick={logout} className={`button_more_div button_more_div_${props.color_background}`} title="Log out">
            <i className="fa-solid fa-arrow-right-from-bracket"></i>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        color_background: state.getColorBackground.color_background
    }
}
export default connect(mapStateToProps)(Button_Logout);